module.exports = __webpack_public_path__ + "media/images/icon/image-8ce242b0c697064d1ac521877bfda5e2.svg";